module.exports = __webpack_public_path__ + "static/img/spec-right-top.d7206003.png";